












































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoStepper from '@/shared/components/respondeco-stepper.vue'
import RespondecoStep from '@/shared/components/respondeco-step.vue'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import { RecoverPasswordForm } from '@/business/account/models/recover-password-form'
import { Hooks } from '@/shared/interfaces/hooks'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import UnifyPage from '@/shared/components/unify/unify-page.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { Steppable } from '@/shared/interfaces/steppable'
import { Injector } from '@/config/dependency-injection'
import { PasswordRecoveryService } from '@/business/account/password-recovery-service'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import { Prop } from 'vue-property-decorator'
import { email, FormGroup, formGroup, minLength, required, sameAs } from '@tf/forms'
import TfForm from '@/shared/tf/forms/tf-form.vue'
import TfInput from '@/shared/tf/forms/tf-input.vue'
import TfFormGroup from '@/shared/tf/forms/tf-form-group.vue'
import TfValidationFeedback from '@/shared/tf/forms/tf-validation-feedback.vue'
import TfStepper from '@/shared/tf/stepper/tf-stepper.vue'
import TfStep from '@/shared/tf/stepper/tf-step.vue'
import TfLabel from '@/shared/tf/forms/tf-label.vue'
import { transformError } from '@/shared/utils/transform-error'
import { PasswordRecoveryMessages } from '@/business/account/models/password-recovery-messages'
import { keys } from '@/shared/utils/keys'
import { isNotBlank } from '@/shared/utils/is-blank'
import { MetaService } from '@/shared/services/meta-service'

@Component({
  name: 'recover-password',
  components: {
    TfLabel,
    TfStep,
    TfStepper,
    TfValidationFeedback,
    TfFormGroup,
    TfInput,
    TfForm,
    RespondecoValidationFeedback,
    UnifyButton,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    UnifyPage,
    RespondecoFormGroup,
    RespondecoTypedForm,
    RespondecoStep,
    RespondecoStepper,
  },

  data() {
    return {
      form: undefined,
      test: undefined,
    }
  },
})
export default class RecoverPassword extends Vue implements Hooks {
  @Prop({
    required: false,
    type: String,
  })
  public readonly token?: string

  @Prop({
    required: false,
    type: String,
  })
  public readonly username?: string

  public activeStepIndex: number = 0
  public errorMessage: string | null = null
  public form!: FormGroup<RecoverPasswordForm>

  public messages: PasswordRecoveryMessages = {
    passwordUpdateFailed: false,
    resentToken: false,
    sentMail: false,
    success: false,
    tokenExpired: false,
    tokenValid: false,
  }

  public step1Valid = false
  public step2Valid = false
  public step3Valid = false

  private metaService = Injector.get(MetaService)
  private passwordRecoveryService = Injector.get(PasswordRecoveryService)

  get email(): string | undefined | null {
    return this.form?.get('step1').get('email').value ?? this.username
  }

  get pending() {
    return this.passwordRecoveryService.pending
  }

  get step1() {
    return this.form.get('step1')
  }

  get step2() {
    return this.form.get('step2')
  }

  get step3() {
    return this.form.get('step3')
  }

  get stepper(): Steppable {
    return (this.$refs.stepper as unknown) as Steppable
  }

  public mounted() {
    this.metaService.updateDocumentTitle('recover_password')

    this.form = formGroup<RecoverPasswordForm>('RecoverPassword', {
      step1: {
        email: [email, required],
      },

      step2: {
        token: [required],
      },

      step3: {
        confirmation: [sameAs('newPassword')],
        newPassword: [minLength(8), required],
      },
    })

    this.form.onChange(() => {
      this.step1Valid = this.step1.dirty && this.step1.valid
      this.step2Valid = this.step2.dirty && this.step2.valid
      this.step3Valid = this.step3.dirty && this.step3.valid
    })

    this.form.onStateChange(() => {
      this.step1Valid = this.step1.dirty && this.step1.valid
      this.step2Valid = this.step2.dirty && this.step2.valid
      this.step3Valid = this.step3.dirty && this.step3.valid
    })

    if (isNotBlank(this.username)) {
      this.step1
        .get('email')
        .markDirty()
        .markTouched()
        .setValue(this.username)
    }

    if (isNotBlank(this.token)) {
      this.activeStepIndex = 1

      this.step2
        .get('token')
        .markDirty()
        .markTouched()
        .setValue(this.token)

      this.checkToken()
    }

    this.$forceUpdate()
  }

  public checkToken() {
    const token = this.form.get('step2').value?.token

    if (this.form.get('step2').valid && token) {
      this.passwordRecoveryService
        .checkToken(token.trim())
        .then(() => {
          this.stepper.select('step3')

          this.showMessage('tokenValid')
        })
        .catch(() => {
          this.showMessage('tokenExpired')
        })
    }
  }

  public resendToken(): void {
    const username = this.step1.get('email').value ?? this.username

    if (username) {
      this.form
        .get('step2')
        .get('token')
        .setValue('')

      this.passwordRecoveryService.initializeRecovery(username).then(() => {
        this.showMessage('resentToken')
      })
    }
  }

  public sendEmail() {
    const email = this.form.get('step1').value?.email

    if (this.form.get('step1').valid && email) {
      this.passwordRecoveryService
        .initializeRecovery(email)
        .then(() => {
          this.stepper.select('step2')
          this.showMessage('sentMail')
        })
        .catch(response => {
          this.errorMessage = transformError(response.error, 'password_recovery.could_not_send')
        })
    }
  }

  public toStep1() {
    this.form
      .get('step2')
      .get('token')
      .setValue(null)

    this.hideMessages()

    this.stepper.select('step1')
  }

  public toStep2() {
    this.hideMessages()

    this.stepper.select('step2')
  }

  public updatePassword() {
    const password = this.step3.get('newPassword').value
    const token = this.step2.get('token').value

    if (this.step3.valid && this.step3.dirty && password && token) {
      this.passwordRecoveryService
        .updatePassword(password, token)
        .then(() => {
          this.stepper.select(3)
          this.showMessage('success')
        })
        .catch(() => {
          this.showMessage('passwordUpdateFailed')
        })
    }
  }

  private hideMessages(): void {
    keys(this.messages).forEach(key => {
      this.messages[key] = false
    })
  }

  private showMessage(key: keyof PasswordRecoveryMessages): void {
    this.errorMessage = null

    this.hideMessages()

    if (key) {
      this.messages[key] = true
    }
  }
}
